// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"c52211d5","107":"4d4857fe","127":"a774d07d","453":"30900952","522":"4c04df1f","876":"098e458a","970":"ce9e018c"}[chunkId] + ".chunk.js";
};